module.exports = __webpack_public_path__ + "img/guide_1.4e43db3e.png";